<template>
    <div>
        <serp-job-skel v-if="isLoading" />
        <div v-for="(job, index) of jobs" v-bind:key="index">
            <li v-if="!isScraped">
                <a v-bind:href="job.sourceLink" class="job-list-item xml-job-item"  target="_blank">
                    <div class="job-item-logo">
                        <img v-bind:src="job.companyLogoUrl" width="78" height="78" v-bind:alt="job.title">
                    </div>
                    <div class="job-item-info">
                        <p class="xml-f-job"><strong>Featured Job</strong> <i class="material-icons" >beenhere</i></p>
                        <h4 style="padding-right:40px!important;font-weight:800" v-text="job.title"></h4>
                        <p class="job-item-company"><i class="material-icons notranslate"
                                    style="margin-left: -4px;font-size: 20px;margin-top: -3px;">work</i> <span class="notranslate" style="color:black"
                                v-text="job.company"></span></p>
                        <p class="job-item-company"><i class="material-icons notranslate"
                                    style="margin-left: -4px;font-size: 20px;margin-top: -3px;">location_on</i> <span class="notranslate"
                                v-if="job.city != undefined" v-text="job.city" style="color:black"></span><span
                                class="notranslate" v-if="job.state != undefined" style="color:black">,</span> <span
                                class="notranslate" v-if="job.state != undefined"
                                v-text="job.state" style="color:black"></span></p>
                                <p class="xml-f-descript" v-text="job.description"></p>
                        <div class="job-item-action">
                            <a type="button" id="" class="btn btn-sm btn-primary xmlfeaturebtn" style="" v-bind:href="job.sourceLink" target="_blank">Apply to job</a>
                        </div>
                    </div>
                </a>
            </li>
            <li v-if="isScraped">
                <a v-bind:href="job.sourceLink" class="job-list-item xmlscraped"  target="_blank">
                    <div class="job-item-info">
                        <span class="badge bg-secondary" style="color:white;font-size: 10px;" v-if="isScraped"><strong>Selected Job</strong></span>
                        <p class="job-item-company" style="color:black!important;font-size:17px"><span style="color:black!important;" v-text="job.title"></span> - <span class="notranslate" style="color:black"
                                v-text="job.company"></span></p>
                    </div>
                    <div class="job-item-action " v-if="isScraped">
                            <a type="button" id="" class="btn btn-sm btn-outline-primary" style="border-radius: 30px;margin-top:7px;" v-bind:href="job.sourceLink" target="_blank">Complete</a>
                    </div>
                </a>
            </li>
        </div>
    </div>
</template>
<script>
export default {
    props: ['sessions'],
    data() {
        return {
            jobs: [],
            isLoading: true,
            isError: false,
            session: this.sessions,
            isScraped: false
        }
    },
    methods: {
        hasXmljob()
        {
            let formatedjobs = [];
            this.isLoading = true;
            if(this.sessions.xmljob != undefined) {
                var job = this.sessions.xmljob;
                if(job.type == "scraped"){
                    this.isScraped = true;
                }
                if(job.companyLogoUrl == undefined || job.companyLogoUrl == ""){
                    if(this.sessions.companyImage != undefined) {
                        job.companyLogoUrl = this.sessions.companyImage.image;
                    }else if(this.sessions.keywordImage != undefined) {
                        job.companyLogoUrl = this.sessions.keywordImage.image;
                    }
                }
                if(job.description.length > 200) job.description = job.description.substring(0,200)+"....";
                formatedjobs.push(job);
            }
            this.jobs = formatedjobs;
            this.isLoading = false
        }
    },
    async mounted() {
        this.hasXmljob();
    }
}
</script>
